import React from 'react';
import { Heading } from '@chakra-ui/react';

export const Header = () => (
    <Heading as="h1" size="2xl">
        Exploratory Data Analysis
    </Heading>
);
